export const validPresentations = ['PPTX', 'G-SLIDES'];
export const validDocuments = ['PDF', 'DOC', 'DOCX', 'G-DOC', 'PPT', 'PPTX', 'G-SLIDES', 'PPSX'];